import axios from 'axios'
export default {
  name: 'Pedido',
  components: { },
  data () {
    return {
      errores: [], pedido: '', lineas: '', estado: 2
    }
  },
  props:['id'],
  mounted () {
    this.consultarpedidoapi()
  },
  methods: {
    listapiezas (lista) {
      return _.orderBy(lista, ['id'], ['desc'])
    },
    consultarpedidoapi () {
      if (this.$store.getters.islogin === true){
          axios.get(this.$apibase+'gen/verpedido/', {
            params: {
              'id': this.id,'cred': this.$store.getters.credactual, '4665': this.$store.getters.idactual
            }
          })
          .then( response => this.procesarpedido(response),  response => this.errorprocesarpedido(response) )
          .catch( response => this.errorprocesarpedido(response))
      } else {
        errorprocesarpedido ('notcred')
      }
    },
    procesarpedido (response) {
      if(response.data.estado === 1){
        this.estado = 1
        this.lineas = response.data.lineas
        this.pedido = response.data.pedido
      }
    },
    errorprocesarpedido (response) {
      this.estado = 2
      console.log(response)
    },
    volverpedidos () {
      if (this.pedido.estado !== 8) {
        this.$router.push('/pedidos')  
      } else{
        this.$router.go(-1)  
      }
      
    },
    descargararchivo () {
      window.open(this.pedido.urlarchivo,'_blank');
    },
    colorescanto1: function (canto) {
    if (canto === 1) {
      return 'canto1azul'
    } else if (canto === 2){
      return 'canto1rojo'
    } else {
      return 'canto1gris'
    }
   },
   colorescanto2: function (canto) {
    canto = _.parseInt(canto)
    if (canto === 1) {
      return 'canto2azul'
    } else if (canto === 2){
      return 'canto2rojo'
    } else {
      return 'canto2gris'
    }
   },
    colorescanto3: function (canto) {
    if (canto === 1) {
      return 'canto3azul'
    } else if (canto === 2){
      return 'canto3rojo'
    } else {
      return 'canto3gris'
    }
   },
   colorescanto4: function (canto) {
    if (canto === 1) {
      return 'canto4azul'
    } else if (canto === 2){
      return 'canto4rojo'
    } else {
      return 'canto4gris'
    }
   },
   enviarabiblioteca (){
    var url = '/enviarabiblioteca/'+this.pedido.id
    this.$router.push(url) 
   },
    enviarapedido () {
      let actuales = 0
      if (this.$store.getters.cantidadpiezas >= 1) {
        actuales = _.maxBy(this.$store.getters.piezas, function (o) { return o.id })
        actuales = actuales['id']
      }
      var store = this.$store
      _.forEach(this.lineas, function(value, key) {
        actuales = ++actuales
        var nuevapieza = {id: actuales, cantidad: value.cantidad, largo: value.largo, ancho: value.ancho, canto1: value.canto1, canto2: value.canto2, canto3: value.canto3, canto4: value.canto4, giro: value.giro, detalle: value.descripcion}
        store.commit('AGREGAR_PIEZA_DE_BIBLIOTECA_MUTATION', nuevapieza)
      })
      this.$router.push('/listador')  
    }
  },
  computed: {
    totalmts2 () {
      var piezas = this.lineas
      var total = this.$store.getters.cal_totalmt2(piezas)
      return total
    },
    totalmtl045 () {
      var piezas = this.lineas
      var total = this.$store.getters.cal_totalmtl045(piezas)
      return total
    },
    totalmtl2 () {
      var piezas = this.lineas
      var total = this.$store.getters.cal_totalmtl2(piezas)
      return total
    },
    totalcorte () {
      var piezas = this.lineas
      var total = this.$store.getters.cal_totalmtcortes(piezas)
      return total
    },
    lugarenvio (){
      if(this.estado === 1){
        if(this.pedido.idcliente === this.pedido.idproveedor){
          return 'mi mail el '+this.pedido.fecha
        } else if (this.pedido.idproveedor === 1){
          return 'mi dispositivo el '+this.pedido.fecha 
        }else{
          var pro = parseInt(this.pedido.idproveedor)
          var datos = this.$store.getters.datosproveedor(pro)
          if(datos){
            return datos.nombre+' el '+this.pedido.fecha
          }else{
            return this.pedido.fecha
          }
          
        }
      }
      return false
    },
    fecha_recibido () {
      if(this.pedido.fecha_recibido){
        return this.pedido.fecha_recibido
      }else{
        return false
      }

    },
    nombrematerial () {
      if (this.pedido.material == 2) {
        return 'Melamínico Otro MDF 18mm 2600x1830'
      } else if (this.pedido.material == 3) {
        return 'Melamínico Otro MDF 18mm 2750x1830'
      } else {
        return 'Melamínico Blanco MDF 18mm 2600x1830'
      }
    },
    colorplaca () {
      if (this.pedido.material >= 2) {
        return 'Color: '+this.pedido.colorplaca
      }
    },
    colorcanto () {
      return 'Color: '+this.pedido.colorcanto
    },
    cargacompleta () {
      if (this.estado == 1) {
        return true
      } else {
        return false
      }
    }
  },
  watch: {
  }
}


// WEBPACK FOOTER //
// ./src/components/js/pedido.js